import * as React from 'react';
import { SplitKitSwitch } from '@xingternal/splitkit';
import { FeatureCondition } from '@xingternal/feature-condition';
import { FeatureSwitch } from '@xingternal/feature-switch';
import { IconBusinessSolutions, IconBusinessSolutionsFilled, IconCompanies, IconCompaniesFilled, IconContact, IconContactFilled, IconContacts, IconContactsFilled, IconEvents, IconEventsFilled, IconGroups, IconGroupsFilled, IconHome, IconHomeFilled, IconJobs, IconJobsFilled, IconLogout, IconMessages, IconMessagesFilled, IconMore, IconNews, IconNewsFilled, IconNotificationCenter, IconNotificationFilled, IconOtherServices, IconOtherServicesFilled, IconPremium, IconPremiumFilled, IconProBusiness, IconProBusinessFilled, IconProJobs, IconProJobsFilled, IconRocket, IconSettings, } from '@xingternal/icons';
function HtmlElement({ as: Component, ...props }) {
    return React.createElement(Component, { ...props });
}
export const utils = {
    Fragment: React.Fragment,
    HtmlElement,
};
export const conditions = {
    SplitKitSwitch,
    FeatureSwitch,
    FeatureCondition,
};
export const icons = {
    IconBusinessSolutions,
    IconBusinessSolutionsFilled,
    IconCompanies,
    IconCompaniesFilled,
    IconContact,
    IconContactFilled,
    IconContacts,
    IconContactsFilled,
    IconEvents,
    IconEventsFilled,
    IconGroups,
    IconGroupsFilled,
    IconHome,
    IconHomeFilled,
    IconJobs,
    IconJobsFilled,
    IconLogout,
    IconMessages,
    IconMessagesFilled,
    IconMore,
    IconNews,
    IconNewsFilled,
    IconNotificationCenter,
    IconNotificationFilled,
    IconOtherServices,
    IconOtherServicesFilled,
    IconPremium,
    IconPremiumFilled,
    IconProBusiness,
    IconProBusinessFilled,
    IconProJobs,
    IconProJobsFilled,
    IconRocket,
    IconSettings,
};
export const commonMetaRendererResolvers = {
    ...utils,
    ...conditions,
    ...icons,
};
//# sourceMappingURL=common-meta-renderer-resolvers.js.map